'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Group = require('./Group');

var _Group2 = _interopRequireDefault(_Group);

var _InputCheckbox = require('./InputCheckbox');

var _InputCheckbox2 = _interopRequireDefault(_InputCheckbox);

exports['default'] = _createReactClass2['default']({

  displayName: 'Demo.Controls.ControlBool',

  propTypes: {
    name: _propTypes2['default'].string.isRequired,
    value: _propTypes2['default'].bool.isRequired,
    onChange: _propTypes2['default'].func.isRequired
  },

  render: function render() {
    var _props = this.props;
    var name = _props.name;
    var value = _props.value;
    var onChange = _props.onChange;

    return _react2['default'].createElement(
      _Group2['default'],
      { name: name },
      _react2['default'].createElement(_InputCheckbox2['default'], { value: value, onChange: onChange })
    );
  }
});
module.exports = exports['default'];